'use client';

import React from 'react';
import { Button, Modal } from 'react-bootstrap';
// import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';

import styles from './language-selector.module.scss';
import { availableLanguages } from '../../_services/common.service';
import { event } from '@lib/ga';

interface LanguageSelectorProps {
  show: boolean;
  onHide: () => void;
  selectedLanguage: string;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  show,
  onHide,
  selectedLanguage
}) => {
  const t = useTranslations("LanguageSelector");
  // const router = useRouter();

  const getCountryFlag = (code: string) => {
    // Convert language code to country code for flag emoji
    const countryMap: { [key: string]: string } = {
      'en': 'US', // English -> USA
      'fr': 'FR', // French -> France
      // Add more mappings as needed
    };

    const countryCode = countryMap[code] || code.toUpperCase();
    return countryCode
      .toUpperCase()
      .replace(/./g, char => 
        String.fromCodePoint(char.charCodeAt(0) + 127397)
      );
  };

  const onSelectLanguage = (code: string) => {
    document.cookie = `NEXT_LOCALE=${code}; path=/; max-age=2592000`;
    // router.refresh(); // Re-render with new locale

    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide}
      className={styles.modal}
      dialogClassName={styles.dialog}
    >
      <div className={styles.handle} />
      
      <Modal.Body className={styles.modalBody}>
        <h2>{t("selectLanguage")}</h2>

        <div className={styles.languageList}>
          {availableLanguages.map((language: { code: string, name: string }) => (
            <button
              id={`nav-language-option-${language.code}`}
              key={language.code}
              className={`${styles.languageOption} ${selectedLanguage === language.code ? styles.active : ''}`}
              onClick={() => {
                event({
                  action: 'language_selected',
                  category: 'navigation_interaction',
                  label: `Language: ${language.code}`,
                });

                onSelectLanguage(language.code);
                onHide();
              }}
            >
              <div className={styles.flagContainer}>
                <span className={styles.flag}>
                  {getCountryFlag(language.code)}
                </span>
              </div>
              <span className={styles.languageName}>{language.name}</span>
              {selectedLanguage === language.code && (
                <svg className={styles.checkIcon} width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM16.78 9.7L11.11 15.37C10.97 15.51 10.78 15.59 10.58 15.59C10.38 15.59 10.19 15.51 10.05 15.37L7.22 12.54C6.93 12.25 6.93 11.77 7.22 11.48C7.51 11.19 7.99 11.19 8.28 11.48L10.58 13.78L15.72 8.64C16.01 8.35 16.49 8.35 16.78 8.64C17.07 8.93 17.07 9.4 16.78 9.7Z" fill="#379777"/>
                </svg>
              )}
            </button>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
          <Button id="language-selector-close-button" className={`${styles.button} ${styles.primary}`} onClick={() => onHide()}>
              {t('CLOSE')}
          </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LanguageSelector;
